// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__HDlkj","footer":"ModalFilter_footer__2yWgY"};